module.exports = __webpack_public_path__ + "img/role05.0b690725.png";